import { PageResponseVm } from 'api/core/page-response.vm';
import { ReplenishmentOrderVm } from './replenishment-order.vm';
import { IsString, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';

export class GetReplenishmentOrdersVm extends PageResponseVm<ReplenishmentOrderVm, string> {
    @IsString()
    nextOffset: string;

    @ValidateNested({ each: true })
    @Type(() => ReplenishmentOrderVm)
    objects: ReplenishmentOrderVm[];
}
